// src/components/common/ImageGallery.jsx
import { useState } from "react";
import { AddImagesButton } from "../AddImagesButton";

export function ImageGallery({ imagenes, onDeleteImage, onAddImages, isOwner }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deletingImageId, setDeletingImageId] = useState(null);

  if (!imagenes || imagenes.length === 0) {
    return (
      <div style={{ marginBottom: "24px" }}>
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#1e293b",
            margin: "0 0 16px 0",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
         Imágenes del Reclamo (0)
        </h3>

        {isOwner && onAddImages && (
          <AddImagesButton
            onImagesAdd={onAddImages}
            currentImagesCount={0}
            maxImages={5}
          />
        )}

        {isOwner && (
          <div
            style={{
              padding: "12px",
              backgroundColor: "#f0f9ff",
              border: "1px solid #bae6fd",
              borderRadius: "6px",
              fontSize: "14px",
              color: "#0369a1",
            }}
          >
            💡 <strong>Sos el creador de este reclamo</strong>. Podés agregar imágenes usando el botón de arriba.
          </div>
        )}
      </div>
    );
  }

  const openImage = (imagen) => {
    setSelectedImage(imagen);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const currentIndex = imagenes.findIndex((img) => img.id === selectedImage.id);
    const newIndex =
      direction === "next"
        ? (currentIndex + 1) % imagenes.length
        : (currentIndex - 1 + imagenes.length) % imagenes.length;
    setSelectedImage(imagenes[newIndex]);
  };

  const handleDeleteImage = async (imagen, event = null) => {
    if (event) event.stopPropagation();

    if (!window.confirm("¿Estás seguro de que querés eliminar esta imagen?")) return;

    setDeletingImageId(imagen.id);
    try {
      await onDeleteImage(imagen.id);
      if (showModal) closeModal();
    } catch (error) {
      console.error("Error eliminando imagen:", error);
    } finally {
      setDeletingImageId(null);
    }
  };

  return (
    <>
      <div style={{ marginBottom: "24px" }}>
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#1e293b",
            margin: "0 0 16px 0",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
         Imágenes del Reclamo ({imagenes.length})
        </h3>

        {isOwner && onAddImages && (
          <AddImagesButton
            onImagesAdd={onAddImages}
            currentImagesCount={imagenes.length}
            maxImages={5}
          />
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
            gap: "12px",
          }}
        >
          {imagenes.map((imagen, index) => (
            <div
              key={imagen.id || index}
              style={{
                position: "relative",
                borderRadius: "8px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
              onClick={() => openImage(imagen)}
            >
              <img
                src={imagen.url}
                alt={`Imagen ${index + 1} del reclamo`}
                style={{
                  width: "100%",
                  height: "100px",
                  objectFit: "cover",
                  display: "block",
                  opacity: deletingImageId === imagen.id ? 0.5 : 1,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "4px",
                  right: "4px",
                  background: "rgba(0, 0, 0, 0.7)",
                  color: "white",
                  borderRadius: "4px",
                  padding: "2px 6px",
                  fontSize: "10px",
                  fontWeight: "600",
                }}
              >
                {index + 1}
              </div>

              {isOwner && (
                <button
                  onClick={(e) => handleDeleteImage(imagen, e)}
                  disabled={deletingImageId === imagen.id}
                  style={{
                    position: "absolute",
                    top: "4px",
                    left: "4px",
                    background: "rgba(239, 68, 68, 0.9)",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    width: "24px",
                    height: "24px",
                    fontSize: "12px",
                    cursor:
                      deletingImageId === imagen.id ? "not-allowed" : "pointer",
                  }}
                  title="Eliminar imagen"
                >
                  {deletingImageId === imagen.id ? "⋯" : "×"}
                </button>
              )}
            </div>
          ))}
        </div>

        {isOwner && imagenes.length > 0 && (
          <div
            style={{
              marginTop: "12px",
              padding: "8px 12px",
              backgroundColor: "#f0f9ff",
              border: "1px solid #bae6fd",
              borderRadius: "6px",
              fontSize: "12px",
              color: "#0369a1",
            }}
          >
            💡 <strong>Sos el creador de este reclamo</strong>. Podés agregar más imágenes o eliminar las existentes.
          </div>
        )}
      </div>

      {showModal && selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "20px",
          }}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "-40px",
                right: "0",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>

            {isOwner && (
              <button
                onClick={() => handleDeleteImage(selectedImage)}
                disabled={deletingImageId === selectedImage.id}
                style={{
                  position: "absolute",
                  top: "-40px",
                  right: "50px",
                  background:
                    deletingImageId === selectedImage.id
                      ? "#94a3b8"
                      : "rgba(239, 68, 68, 0.9)",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor:
                    deletingImageId === selectedImage.id
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {deletingImageId === selectedImage.id
                  ? "⏳ Eliminando..."
                  : "🗑️ Eliminar Imagen"}
              </button>
            )}

            {imagenes.length > 1 && (
              <button
                onClick={() => navigateImage("prev")}
                style={navBtn("left")}
              >
                ‹
              </button>
            )}

            <img
              src={selectedImage.url}
              alt="Imagen ampliada"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />

            {imagenes.length > 1 && (
              <button
                onClick={() => navigateImage("next")}
                style={navBtn("right")}
              >
                ›
              </button>
            )}

            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                padding: "8px 16px",
                borderRadius: "20px",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {imagenes.findIndex((img) => img.id === selectedImage.id) + 1} /{" "}
              {imagenes.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function navBtn(side) {
  return {
    position: "absolute",
    [side]: "20px",
    background: "rgba(255, 255, 255, 0.2)",
    border: "none",
    color: "white",
    fontSize: "24px",
    cursor: "pointer",
    padding: "12px 16px",
    borderRadius: "8px",
  };
}